module.exports = __webpack_public_path__ + "media/images/pages/secondary-toolkit/secondary_careers-b80b2149ecf80d8d64dea865a411a3e8.jpeg";